
import React, { useState } from 'react';
import { Camera, Book, Heart, Play, Pause, Video, Mic, Upload, Users, Home, Settings, Star, Cloud, Moon, Sun, ChevronRight, Plus, Check, X, Mail, Lock, User, ArrowRight } from 'lucide-react';

export const Input = ({ icon: Icon, type = 'text', placeholder, value, onChange, style = {} }) => {
  return (
    <div style={{ position: 'relative', width: '100%' }}>
      {Icon && (
        <div style={{ position: 'absolute', left: '1rem', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none' }}>
          <Icon style={{ width: '1.25rem', height: '1.25rem', color: '#9ca3af' }} />
        </div>
      )}
      <input
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        style={{
          width: '100%',
          padding: Icon ? '0.875rem 1rem 0.875rem 3rem' : '0.875rem 1rem',
          border: '2px solid #e5e7eb',
          borderRadius: '0.75rem',
          fontSize: '1rem',
          outline: 'none',
          transition: 'border-color 0.3s',
          boxSizing: 'border-box',
          ...style
        }}
        onFocus={(e) => e.target.style.borderColor = '#9333ea'}
        onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
      />
    </div>
  );
};